/**
 * Synchronously reads the stationCode query parameter from window.location.search.
 *
 * Used at store creation time so that stationCode is available in Redux
 * before any React component mounts or useEffect fires — eliminating the
 * race condition where API calls execute before the async hook-based
 * resolution completes.
 */
export function getStationCodeFromUrl(): string | null {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('stationCode');
  } catch {
    return null;
  }
}
